import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import styles from "./index.module.css";

export default function ReportItemPlatinumPlus({
  item,
  isOdd,
  type,
  staticColumns = [],
  allColumns = [],
  groupedHeaders = [],
  dynamicWidth = 40,
  selectedColumns = [],
}) {
  const renderStaticValue = (col) => {
    if (type === "total") {
      if (col.id === "ibo") return item.ibo;
      return "";
    }

    return item[col.id];
  };

  return (
    <div className={classNames(styles.iboItem, isOdd && styles.odd)}>
      {staticColumns.map((col) => (
        <div
          key={col.id}
          className={styles[col.id]}
          style={{
            flex: `0 0 ${col.width}%`,
            maxWidth: `${col.width}%`,
            fontWeight:
              type === "total" && col.id === "ibo" ? "bold" : "normal",
          }}
        >
          {renderStaticValue(col)}
        </div>
      ))}

      <div
        className={styles.dynamicColumnsBox}
        style={{
          flex: `0 0 ${dynamicWidth}%`,
          maxWidth: `${dynamicWidth}%`,
        }}
      >
        {allColumns.map((col, index) => {
          const columnName = col.name || col.columnName || col.headerName;
          const rawValue = item.values?.[col.groupName]?.[columnName] ?? 0;
          const isSelected = selectedColumns.includes(col.id);

          const isFirstInGroup = groupedHeaders.some(
            (group) => group.columns[0]?.id === col.id
          );

          let displayValue = "";

          if (isSelected) {
            displayValue =
              type === "total" ? rawValue : rawValue === 0 ? "-" : rawValue;
          }

          return (
            <div
              key={`${col.id}-${index}`}
              className={classNames(
                styles.col,
                isFirstInGroup && styles.firstDynamicInGroup
              )}
              style={{
                width: `${100 / (allColumns.length || 1)}%`,
                opacity: isSelected ? 1 : 0.35,
              }}
            >
              {displayValue}
            </div>
          );
        })}
      </div>
    </div>
  );
}

ReportItemPlatinumPlus.propTypes = {
  item: PropTypes.object,
  isOdd: PropTypes.bool,
  type: PropTypes.string,
  staticColumns: PropTypes.array,
  allColumns: PropTypes.array,
  groupedHeaders: PropTypes.array,
  dynamicWidth: PropTypes.number,
  selectedColumns: PropTypes.array,
};
